export default __webpack_public_path__ + "static/logo-4184a9e09d9759bd4041f14e3c8d2dcd.svg";